import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BaseComponent, SpinnerComponent } from '@lib/components';
import { ApiResponseError, IAccountFundsResponse, IFormGroupSchema, ILoadFundsForm } from '@lib/interfaces';
import { ValueFieldModule } from '@lib/modules';
import { AccountsService } from '@lib/services';
import { finalize } from 'rxjs';
import { AngularMaterialModule } from 'src/app/material.module';

@Component({
    standalone: true,
    selector: 'app-load-funds',
    templateUrl: './load-funds.component.html',
    styleUrls: ['./load-funds.component.scss'],
    imports: [AngularMaterialModule, ValueFieldModule, SpinnerComponent],
})
export class LoadFundsComponent extends BaseComponent {
    protected readonly currencies = ['SAR'];
    protected isLoading = false;

    protected loadFundsForm: FormGroup<IFormGroupSchema<Partial<ILoadFundsForm>>> = this.initializeForm();

    constructor(private readonly formBuilder: FormBuilder, private loadFundsRef: MatDialogRef<LoadFundsComponent>, @Inject(MAT_DIALOG_DATA) public data: { accountId: any, initialLoad: true }, private accountsService: AccountsService, private snackbar: MatSnackBar) {
        super();
    }

    protected initializeForm(): FormGroup<IFormGroupSchema<Partial<ILoadFundsForm>>> {
        return new FormGroup<IFormGroupSchema<Partial<ILoadFundsForm>>>({
            amount: this.formBuilder.nonNullable.control(undefined, [Validators.required, Validators.min(1)]),
            note: this.formBuilder.nonNullable.control(''),
            currency: this.formBuilder.nonNullable.control('SAR', [Validators.required]),
            dry_run: this.formBuilder.nonNullable.control(false),
        });
    }

    protected closeModal(loadedFunds = false) {
        this.loadFundsRef.close(loadedFunds);
    }

    protected loadFunds() {
        if (this.loadFundsForm.valid) {
            this.isLoading = true;
            const formValue = this.loadFundsForm.value;
            const payload: ILoadFundsForm = {
                currency: formValue.currency!,
                amount: formValue.amount!,
                note: formValue.note? formValue.note : 'Added by user',
                dry_run: formValue.dry_run!,
            };
            this.accountsService
                .loadFunds(payload, this.data.accountId, this.data.initialLoad ? 'initialLoadFunds' : 'loadFunds')
                .pipe(
                    finalize(() => {
                        this.isLoading = false;
                    }),
                )
                .subscribe({
                    next: (accountFunds: IAccountFundsResponse): void => {
                        if (accountFunds?.result.status === 'DECLINED') {
                            this.createApiErrorSnackBar(this.snackbar, accountFunds?.result.status_description || accountFunds?.result.status_reason);
                        }
                        this.createApiSuccessSnackBar(this.snackbar, 'Topup successful!!');
                        this.closeModal(true);
                    },
                    error: (error: ApiResponseError): void => {
                        this.createApiErrorSnackBar(this.snackbar, error);
                    },
                });
        }
    }
}
